import PastAppointments from "./PastAppointments";

export default PastAppointments;
